import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import classnames from 'classnames';

const Loading = createClass({
  propTypes: {
    active: PropTypes.bool,
    message: PropTypes.string,
    className: PropTypes.string
  },

  getDefaultProps() {
    return {
      message: ''
    };
  },

  render() {
    const {active, className} = this.props;
    if (!active) return null;

    const containerClassNames = classnames('vf-spinner', className, {active});

    return (
      <div className={containerClassNames}>
        <div className='vf-double-bounce1' />
        <div className='vf-double-bounce2' />
      </div>
    );
  }
});

module.exports = Loading;
